import React from "react";
import PropTypes from "prop-types";
import AppUtils from "@src/utils/appUtils";
import SavingsCard from "@src/components/cards/SavingsCard";
import { COMMON_CONTROLS } from "@src/stories/utils/common-controls";

/** Calculates and Displays total CO2 savings for an Event. For the inner card see SavingsCard */
const EventSavingsCard = (props) => {
  const { event, industry } = props;

  const totalCarbonSavings = () => {
    const co2Saved = event.behaviours.reduce((total, bvr) => {
      return bvr.succeeded && bvr.CO2SavedKg > 0
        ? total + bvr.CO2SavedKg
        : total;
    }, 0);
    return co2Saved;
  };

  return (
    <SavingsCard mode="co2" value={totalCarbonSavings()} industry={industry} />
  );
};

export const eventSavingsCardControls = {
  event: {
    propType: PropTypes.object,
    description: "Event data object",
    controlType: "object",
  },
  industry: COMMON_CONTROLS.industry,
};

EventSavingsCard.propTypes = AppUtils.getPropTypeFromControls(
  eventSavingsCardControls,
);

export default EventSavingsCard;
